import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.production";

@Injectable({
    providedIn: 'root'
})
export class CatEfectoCertificado {

    constructor(private http: HttpClient){

    }

    private endPoint: string = `${environment.HOST_CAT}`;


    postQuery(query: string, url: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(url, query, { headers });
  }


  /** METODO QUE CONSUME EL SERVICIO DE TIPO GET */
  getQuery(query: string, url: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(url + '' + query, { headers });
  }


  catEfectoCertificado(){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(this.endPoint+`catEfectoCertificado`, { headers });
  }


}
